import React, { Suspense } from 'react';
import dynamic from 'next/dynamic';

import { cn } from '@lyearn/style';
import { Drawer } from '@lyearn/ui';
import Error403 from '@/components/Error/403';

import useKnowledgeBaseEnabled from './hooks/useKnowledgeBaseEnabled';
import { height100vh } from './styles';

// The copilot index reaches ContentView → ArticleViewer → AI builders (~1.6k modules).
// Loading it on drawer open keeps that subtree out of _app's graph — this drawer is
// mounted (closed) in the header on every page.
const KnowledgeBaseCopilot = dynamic(() => import('.'), { ssr: false });

interface CoachRightDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  startInTeachMode?: boolean;
}

function CoachRightDrawer(props: CoachRightDrawerProps) {
  const { isOpen, onClose, startInTeachMode } = props;
  const isKnowledgeBaseEnabled = useKnowledgeBaseEnabled();

  return (
    <Suspense fallback={null}>
      <Drawer
        disableEscapeKeyDown
        SlideProps={{ direction: 'left' }}
        anchor="right"
        classes={{ paper: cn(height100vh, 'w-full') }}
        open={isOpen}
        onClose={onClose}>
        <Suspense fallback={null}>
          {isKnowledgeBaseEnabled ? (
            <KnowledgeBaseCopilot startInTeachMode={startInTeachMode} onClose={onClose} />
          ) : (
            <Error403 resource="coach" />
          )}
        </Suspense>
      </Drawer>
    </Suspense>
  );
}

export default React.memo(CoachRightDrawer);
